/* Progressive enhancements. Content stays visible and usable without JavaScript. */
(() => {
  if (window.pikoteoReady) return;
  window.pikoteoReady = true;
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const observed = new WeakSet();
  const running = new Set();
  let observer;

  function filterMenu(group, announce = false) {
    document.querySelectorAll('[data-pk-menu-section]').forEach(section => {
      section.hidden = section.dataset.pkMenuSection !== group;
    });
    document.querySelectorAll('[data-pk-menu-filter]').forEach(button => {
      button.setAttribute('aria-pressed', String(button.dataset.pkMenuFilter === group));
    });
    const categorySelect = document.querySelector('[data-pk-category-select]');
    if (categorySelect) {
      while (categorySelect.options.length > 1) categorySelect.remove(1);
      document.querySelectorAll(`[data-pk-menu-section="${group}"] .pk-category`).forEach(category => {
        const option = document.createElement('option');
        option.value = category.id;
        option.textContent = category.querySelector('h2').textContent;
        categorySelect.append(option);
      });
      categorySelect.value = '';
      categorySelect.closest('[data-pk-category-jump]').hidden = false;
    }
    if (announce) {
      const status = document.querySelector('[data-pk-menu-status]');
      if (status) status.textContent = `${group.charAt(0).toUpperCase() + group.slice(1)} menu shown.`;
    }
  }

  function updateGift(gift) {
    const selected = gift.querySelector('.pk-gift-amounts input:checked');
    const value = gift.querySelector('[data-gift-display]');
    if (selected && value) value.textContent = selected.dataset.giftValue || selected.value;
    if (!selected) return;
    const covers = Array.from(gift.querySelectorAll('[data-gift-cover]'));
    const active = covers.find(cover => cover.dataset.giftCover === selected.dataset.giftPrice);
    covers.forEach(cover => { cover.hidden = cover !== active; });
  }

  function init(root = document) {
    root.querySelectorAll('.pk-gift').forEach(updateGift);
    const menuSwitch = document.querySelector('[data-pk-menu-switch]');
    if (menuSwitch) {
      menuSwitch.hidden = false;
      const selected = menuSwitch.querySelector('[aria-pressed="true"]');
      filterMenu(selected?.dataset.pkMenuFilter || 'food');
    }
    if (document.body.dataset.pkMotion !== 'true' || reducedMotion.matches || !('IntersectionObserver' in window) || window.Shopify?.designMode) return;
    if (!observer) observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        if (reducedMotion.matches) return;
        const line = entry.target.matches('.pk-signature');
        const frames = line ? [{ transform: 'scaleX(.92)' }, { transform: 'scaleX(1)' }] : [{ transform: 'translateY(14px)', opacity: .82 }, { transform: 'translateY(0)', opacity: 1 }];
        const animation = entry.target.animate(frames, { duration: line ? 650 : 520, easing: 'cubic-bezier(.2,.7,.2,1)', delay: Number(entry.target.dataset.pkDelay || 0) });
        running.add(animation);
        animation.finished.catch(() => {}).finally(() => running.delete(animation));
      });
    }, { threshold: .12 });
    root.querySelectorAll('[data-pk-reveal], .pk-programme>.pk-shell>.pk-signature').forEach((element, index) => {
      if (observed.has(element)) return;
      observed.add(element);
      element.dataset.pkDelay = element.matches('.pk-dish') ? String((index % 3) * 70) : '0';
      observer.observe(element);
    });
  }

  document.addEventListener('click', event => {
    const menuButton = event.target.closest('[data-pk-menu-filter]');
    if (menuButton) filterMenu(menuButton.dataset.pkMenuFilter, true);
    const link = event.target.closest('.pk-nav--mobile a');
    if (link) {
      const drawer = document.querySelector('#slideout-mobile-navigation');
      if (drawer?.matches(':popover-open')) drawer.hidePopover();
    }
  });
  document.addEventListener('change', event => {
    if (event.target.matches('[data-pk-category-select]')) {
      const category = document.getElementById(event.target.value);
      if (category) { category.scrollIntoView({block:'start', behavior:'instant'}); category.focus({preventScroll:true}); }
      return;
    }
    if (!event.target.matches('.pk-gift-amounts input')) return;
    updateGift(event.target.closest('.pk-gift'));
  });
  reducedMotion.addEventListener('change', () => {
    if (reducedMotion.matches) {
      observer?.disconnect();
      running.forEach(animation => animation.cancel());
      running.clear();
    } else init();
  });
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:block:select', event => {
    const menu = event.target.closest('[data-pk-menu-section]');
    if (menu) filterMenu(menu.dataset.pkMenuSection);
  });
  init();
})();
